import { useParams } from 'react-router-dom'
import { performRequest } from '../../../common/utils'
import Organization from '../Organization/Organization'
import { createContext, useEffect, useState } from 'react'
import Title from "../../../common/title/Title"
import TeamTabs from './TeamTabs'
import MemberTabs from './MemberTabs'
import Card from '../../../common/card/Card'
import ReportingGroup from '../ReportingGroup/ReportingGroup'
import BreadCrumbs from '../../../common/breadcrumbs/BreadCrumbs'
import Loader from '../../../common/loader/Loader'
import { QueryClient, useQuery } from '@tanstack/react-query'
import Manage from '../Manage/Manage'
import TeamSettings from '../TeamSettings/TeamSettings'
import MemberHome from '../MemberHome/MemberHome'
import MemberNav from '../Members/MemberNav'
import { useGroupDashboardContext } from '../GroupDashboardContext'
import LicenseNav from '../Licenses/LicenseNav'

export const TeamContext = createContext()
const MenuTabs = ({ type, breadcrumbs, teamOptionsData, siteOptionsData, siteFiltersData, getTeamType }) => {

    const { setFiltersData, setSelectedTeamType } = useGroupDashboardContext()
    const [ teamResponse, setTeamResponse ] = useState()
    const params = useParams()
    const teamId = params.team_id

    useEffect(() => {
      setFiltersData( siteFiltersData )
    }, [])

    useEffect(() => {
      tangibleFields?.store?.setValue( 'membersync_global_organization_switcher', teamId )
    }, [teamId])

    const queryClient = new QueryClient()
    const {
      isLoading, 
      isPending, 
      isFetching,
      isError, 
      error,
      refetch,
      data } = useQuery({
      queryKey: ['msync_get_team_org_details', teamId],
      queryFn: getTeam,
      refetchOnWindowFocus: false
    }, queryClient)

    async function getTeam( currentTeam ) {
      const teamType = getTeamType(teamId)
      // const formData = new FormData()
      // formData.append('action', 'msync_get_team_org_details')
      // formData.append('team_id', teamId)
      // formData.append('nonce', group_dashboard.nonce_teams)

      try {
        // const request = await performRequest(group_dashboard.ajaxurl, formData)
        // const res = await request.json()
        const res = await Tangible?.ajax('msync_get_team_org_details', {
          team_id: teamId,
          team_type: teamType
        })
        if(!res.success){
          throw new Error( res.errors.shift() )
        }
        setSelectedTeamType( res.team_data.team_type )
        return res.team_data
      } catch (error) {
        console.error(error)
        setTeamResponse( error.toString() )
        return false
      }
    }

    // To do: use useEffect for breadcrumbs 
    const handleBreadcrumbs = ( type, canManage ) => {

      if (typeof type !== 'string' || typeof canManage !== 'boolean') {
        throw new Error('Invalid input parameters')
      }
    
      const root = `/organization/${teamId}`
      const teamLink = [...( breadcrumbs ?? [] ), { icon: '', label: data?.team_name, link: canManage ? root : `${root}/member-home` }]
    
      switch (type) {
        case 'home':
        case 'member-home':
          return teamLink
        case 'members':
          return [...teamLink, { icon: '', label: 'Members', link: `${root}/${type}` }]
        case 'licenses':
          return [...teamLink, { icon: '', label: 'Licenses', link: `${root}/${type}` }]
        case 'reporting-group':
          return [...teamLink, { icon: '', label: 'Reports', link: `${root}/${type}` }]
        case 'manage':
          return [...teamLink, { icon: '', label: 'Manage', link: `${root}/${type}` }]
        case 'team-settings':
          return [...teamLink, { icon: '', label: 'Team Settings', link: `${root}/${type}` }]
        default:
          return breadcrumbs ?? []
      }

    }

    const renderComponentContent = ( type, canManage ) => {
      // console.log('data : ', data)
      switch( true ){
        case type === 'home' && canManage:
          return <Organization teamData={data} />
        case type === 'members' && canManage:
          return <MemberNav teamType={data.team_type} refetchTeamData={ refetch }/>
        case type === 'licenses' && canManage:
          if ( data.member_role !== 'member' ) return <LicenseNav teamType={data.team_type} refetchTeamData={ refetch }/>
        case type === 'reporting-group' && canManage:
          if ( data.team_type === 'msynclicenses' ) {
            if ( data.can_view_reports ) return <ReportingGroup teamData={data} siteOptionsData={siteOptionsData} teamOptionsData={teamOptionsData}/>
          } else {
            return <ReportingGroup teamData={data} siteOptionsData={siteOptionsData} teamOptionsData={teamOptionsData}/>
          }
        case type === 'member-home' && ! canManage:
          return <MemberHome teamData={data} />
        case type === 'manage' && ! canManage:
          return <Manage teamData={data} />
        case type === 'team-settings' && canManage:
          return <TeamSettings teamData={data} teamOptionsData={teamOptionsData} refetchTeamData={ refetch }/>
        default:
          return <Card> 
                  <strong>Permission denied</strong> 
                </Card>
      }
    }

    const renderComponentTabs = ( canManage ) => {
      return canManage 
        ? <TeamTabs teamData={data} teamURL={ data.team_area_url } teamOptionsData={teamOptionsData} teamType={data.team_type} /> 
        : <MemberTabs groupData={ data.groups[0] } teamData={ data } />
    }

    if( isLoading || isPending || isFetching ){
      return (
        <Loader type='spinner-dual-ring'/>
      )
    }

    if( isError ){
      return (
        <Card> 
          <strong> { error.message } </strong> 
        </Card>
      )
    }
    
    return (
      <>
        { 
          teamResponse && teamResponse !== ''
          ? <Card> 
              <strong>{ teamResponse }</strong> 
            </Card>
          : data &&
            <>
              <TeamContext.Provider value={{
                teamData: data,
                refetchTeamData: refetch
              }}>
              <div className="msync-organization-dashboard__header">
                <BreadCrumbs breadcrumbs={ handleBreadcrumbs( type, data.can_manage ) } className='msync-organization-dashboard__header__breadcrumb' />
                <Title value={data.team_name} />
                { renderComponentTabs( data.can_manage ) }
              </div>
              <div className="msync-organization-dashboard__body">
                { renderComponentContent( type, data.can_manage ) }
              </div>
              </TeamContext.Provider>
            </>
          
        } 
      </>
    )
}

export default MenuTabs
